export default __webpack_public_path__ + "static/media/21-Soundcloud-Orange.2bd0d9df.png";